import { graphql } from '../graphql/generated';

export const LAB_SHEET_QUERY = graphql(`
  query LabSheet($labId: ID!) {
    labSheet(labId: $labId) {
      id
      data
    }

    labParameters(labId: $labId) {
      ...SheetEditor_Parameter
    }
  }
`);

export const SAVE_LAB_SHEET_MUTATION = graphql(`
  mutation SaveLabSheet($labId: ID!, $input: SheetInput!) {
    saveLabSheet(labId: $labId, input: $input) {
      id
    }
  }
`);
